import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconVikinghelmet2020Black({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path
				fill="#CD0400"
				d="m18.1 13.7-1.6.6c1 .5 1.4 1.6 1.8 2.9.5.2 1.3.5 1.8.6-.9-1.9-1.5-2.8-2-4.1m-3.7 1.5-2 .8c1.3 1.1 4.1 1.4 4.9.8-.1-.3-.2-.7-.4-1-.7.2-1.8.3-2.5-.6m-8.1 3.2c.2 1.3-.4 3-1.7 4.6-.4.4-.3 1 .4 1h3.8c.6 0 1.3-.7 1.5-1 1.2-1.4 1.8-3.8.9-6.5zm8.1-11c.3-1.7.1-4.8-.8-6.4-.2-.4-.5-.4-.4 0 .4 1.4.1 4.2-.5 5.7.6 0 1.2.2 1.7.7m-6.6 3.4c.7.9 2.7 0 2.5-1.3-.9-1-1.7-1.9-2.1-2.9-.9-2.3-.8-4.9-.4-6.3.1-.4-.3-.5-.5 0-.8 1.9-1.2 3.5-.9 6.7.1 1.5.8 2.9 1.4 3.8"
			/>
			<path d="M16 9.9c-1.6-2.5-4-2.8-6.2-2.5.5.5.9 1.1 1.4 1.6.3.4.3 1.5-.3 2.2-.4.4-1.1.8-2.2.8-.4 0-1.2-.1-1.6-.6s-.7-1.2-1-2.1c-.9.8-2 2.9-1.4 5.3zm0 3.8c1 .5 1.4 1.6 1.8 2.9.5.2 1.3.5 1.8.6-1.1-1.8-1.6-2.7-2.1-4zm-2.2.9-2 .8c1.3 1.1 4.1 1.4 4.9.8-.1-.3-.2-.7-.4-1-.7.2-1.8.3-2.5-.6M5 16.9c2.9-1.2 9.3-3.7 12.2-4.9.1-.5-.1-.9-.5-1.3-3.6 1.4-8.7 3.5-12.3 4.9.1.6.3 1 .6 1.3" />
			<path
				fill="#CD0400"
				d="M15.5 11.6c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4m-2.8 1.1c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c.1-.2.2-.4.4-.4m-3.4 1.4c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c.1-.2.2-.4.4-.4m-3 1.2c.2 0 .4.2.4.4s-.2.4-.4.4c-.2-.1-.3-.2-.3-.5q0-.3.3-.3"
			/>
			<path d="M5.6 17.8c.2 1.3-.4 3-1.7 4.6-.4.4-.3 1 .4 1h3.8c.6 0 1.3-.7 1.5-1 1.2-1.4 1.8-3.8.9-6.5z" />
		</svg>
	);
}
